import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

interface Teste {
  id: string;
  icon: string;
  titulo: string;
  subtitulo: string;
  descricao: string;
  duracao: string;
  perguntas: number;
  resultado: string;
  hashtags: string[];
  cor: string;
  corBg: string;
  corBorder: string;
  link: string;
  preview: { pergunta: string; opcoes: string[] };
  compartilhavel: string;
}

const testes: Teste[] = [
  {
    id: 'diagnostico',
    icon: 'ri-brain-line',
    titulo: 'Diagnóstico de Padrão Mental',
    subtitulo: 'Qual padrão está travando seu próximo nível?',
    descricao: '5 perguntas que identificam o padrão mental dominante que está freando sua evolução — e recomenda a técnica de PNL exata para superá-lo.',
    duracao: '5 min',
    perguntas: 5,
    resultado: 'Seu padrão + protocolo personalizado',
    hashtags: ['#PNL', '#ReprogramacaoMental', '#BiaHolmes', '#DesenvolvimentoPessoal'],
    cor: 'text-gold-400',
    corBg: 'bg-gold-500/10',
    corBorder: 'border-gold-500/25',
    link: '/diagnostico',
    preview: {
      pergunta: 'Quando está prestes a dar um grande passo profissional, você tende a...',
      opcoes: ['Adiar. Amanhã parece sempre melhor.', 'Trabalhar até estar perfeito, mas nunca lançar.', 'Executar com excelência, mas chegar exausta.'],
    },
    compartilhavel: 'Fiz o Diagnóstico de Padrão Mental da @biaholmes e descobri meu padrão limitante. Você sabe qual é o seu? 🧠✨',
  },
  {
    id: 'autoconhecimento',
    icon: 'ri-user-star-line',
    titulo: 'Quiz de Autoconhecimento',
    subtitulo: 'Descubra seu perfil de desenvolvimento',
    descricao: 'Mapeie seu perfil de desenvolvimento pessoal e receba recomendações personalizadas de práticas de PNL e gratidão para sua jornada.',
    duracao: '8 min',
    perguntas: 10,
    resultado: 'Perfil completo + exercícios recomendados',
    hashtags: ['#Autoconhecimento', '#PNL', '#BiaHolmes', '#AltaPerformance'],
    cor: 'text-amber-400',
    corBg: 'bg-amber-500/10',
    corBorder: 'border-amber-500/25',
    link: '/quiz',
    preview: {
      pergunta: 'Quando você pensa nos seus objetivos de vida, como você se sente?',
      opcoes: ['Clara e confiante no caminho.', 'Tenho clareza, mas algo me para.', 'Insegura sobre qual direção seguir.'],
    },
    compartilhavel: 'Descobri meu perfil de autoconhecimento com o quiz da @biaholmes! Qual é o seu? Faça grátis 🌟',
  },
  {
    id: 'bloqueio',
    icon: 'ri-lock-unlock-line',
    titulo: 'Teste de Bloqueio Emocional',
    subtitulo: 'O que está impedindo sua plena realização?',
    descricao: 'Identifique os bloqueios emocionais que sabotam sua carreira, relacionamentos e bem-estar — com insights práticos de PNL clínica.',
    duracao: '6 min',
    perguntas: 7,
    resultado: 'Bloqueio identificado + técnica de liberação',
    hashtags: ['#BloqueioEmocional', '#PNL', '#BiaHolmes', '#Transformacao'],
    cor: 'text-rose-400',
    corBg: 'bg-rose-500/10',
    corBorder: 'border-rose-500/25',
    link: '/diagnostico',
    preview: {
      pergunta: 'Em qual área da sua vida você sente maior resistência interna?',
      opcoes: ['Carreira e dinheiro — sei o que fazer mas não faço.', 'Relacionamentos — crio barreiras sem querer.', 'Saúde e bem-estar — me saboto constantemente.'],
    },
    compartilhavel: 'Descobri meu maior bloqueio emocional com o teste da @biaholmes. Incrível o que a PNL revela 🔓💛',
  },
  {
    id: 'performance',
    icon: 'ri-trophy-line',
    titulo: 'Teste de Alta Performance',
    subtitulo: 'Em que nível de performance você está?',
    descricao: 'Avalie seu nível atual em 5 dimensões-chave de alta performance: foco, energia, mindset, relacionamentos e resultados.',
    duracao: '7 min',
    perguntas: 8,
    resultado: 'Mapa de performance + plano de evolução',
    hashtags: ['#AltaPerformance', '#Mindset', '#BiaHolmes', '#LiderancaFeminina'],
    cor: 'text-violet-400',
    corBg: 'bg-violet-500/10',
    corBorder: 'border-violet-500/25',
    link: '/quiz',
    preview: {
      pergunta: 'Como você avaliaria seu nível de foco e clareza mental no dia a dia?',
      opcoes: ['Foco total — trabalho em estado de flow com frequência.', 'Foco razoável — me distraio mais do que gostaria.', 'Foco fragmentado — dificuldade em sustentar atenção.'],
    },
    compartilhavel: 'Avaliei meu nível de alta performance com o teste da @biaholmes. Você sabe onde está? 🏆',
  },
];

export default function TestesInstagram() {
  const [abaAtiva, setAbaAtiva] = useState(0);
  const [copiado, setCopiado] = useState(false);
  const teste = testes[abaAtiva];

  const copiarLegenda = () => {
    const texto = `${teste.compartilhavel}\n\n${teste.hashtags.join(' ')}\n\n🔗 Link na bio`;
    navigator.clipboard.writeText(texto).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    });
  };

  return (
    <section className="py-28 bg-[#0d0d0d] relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/10 to-transparent" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_30%,rgba(201,164,64,0.05),transparent_60%)]" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">

        {/* Header */}
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="h-px w-8 bg-gold-500/40" />
              <span className="text-gold-400 text-xs font-semibold tracking-[0.3em] uppercase font-['Montserrat']">
                Testes Gratuitos
              </span>
              <div className="h-px w-8 bg-gold-500/40" />
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold text-white leading-tight mb-4">
              Testes para postar<br />
              <span className="text-gold-400">no Instagram</span>
            </h2>
            <p className="text-white/45 text-base max-w-xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Faça gratuitamente, descubra seu resultado e compartilhe com sua audiência — a legenda já está pronta pra você copiar.
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Abas */}
        <ScrollRevealWrapper animation="fade-up" delay={0.1}>
          <div className="flex flex-wrap justify-center gap-2 mb-10">
            {testes.map((t, i) => (
              <button
                key={t.id}
                onClick={() => setAbaAtiva(i)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold font-['Montserrat'] transition-all cursor-pointer whitespace-nowrap border ${
                  abaAtiva === i
                    ? `${t.corBg} ${t.corBorder} ${t.cor}`
                    : 'bg-white/3 border-white/8 text-white/40 hover:text-white/70 hover:border-white/20'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${t.icon} text-sm`} />
                </div>
                {t.titulo.split(' ').slice(0, 2).join(' ')}
              </button>
            ))}
          </div>
        </ScrollRevealWrapper>

        {/* Conteúdo da aba */}
        <ScrollRevealWrapper animation="fade-up" delay={0.15}>
          <div className="grid lg:grid-cols-5 gap-6">

            {/* Card principal — info do teste */}
            <div className="lg:col-span-3 bg-[#111111] border border-white/6 rounded-2xl overflow-hidden">
              {/* Topo colorido */}
              <div className={`relative h-44 overflow-hidden`}>
                <img
                  src={
                    teste.id === 'diagnostico'
                      ? 'https://public.readdy.ai/ai/img_res/4ce97e1c230ff073835b996eda438380.jpg'
                      : teste.id === 'autoconhecimento'
                      ? 'https://readdy.ai/api/search-image?query=woman%20self%20reflection%20mirror%20dark%20luxury%20background%20warm%20golden%20light%20personal%20discovery%20identity%20inner%20journey%20sophisticated%20cinematic%20portrait&width=720&height=250&seq=teste-auto-top&orientation=landscape'
                      : teste.id === 'bloqueio'
                      ? 'https://readdy.ai/api/search-image?query=woman%20breaking%20free%20chains%20liberation%20emotional%20freedom%20dark%20background%20warm%20golden%20light%20empowerment%20cinematic%20dramatic%20portrait%20premium&width=720&height=250&seq=teste-bloq-top&orientation=landscape'
                      : 'https://readdy.ai/api/search-image?query=powerful%20executive%20woman%20dark%20premium%20background%20golden%20light%20rays%20achievement%20trophy%20success%20elite%20performance%20cinematic%20sophisticated%20portrait&width=720&height=250&seq=teste-perf-top&orientation=landscape'
                  }
                  alt={teste.titulo}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/40 to-transparent" />
                <div className="absolute bottom-4 left-6 right-6 flex items-end justify-between">
                  <div className="flex items-center gap-2">
                    <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${teste.corBg} border ${teste.corBorder}`}>
                      <i className={`${teste.icon} ${teste.cor} text-base`} />
                    </div>
                    <div>
                      <span className={`text-xs font-bold font-['Montserrat'] ${teste.cor}`}>{teste.subtitulo}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="text-white/40 text-xs font-['Montserrat'] flex items-center gap-1">
                      <i className="ri-question-line" />{teste.perguntas} perguntas
                    </span>
                    <span className="text-white/40 text-xs font-['Montserrat'] flex items-center gap-1">
                      <i className="ri-time-line" />{teste.duracao}
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-7">
                <h3 className="font-display text-2xl font-bold text-white mb-3">{teste.titulo}</h3>
                <p className="text-white/45 text-sm font-['Montserrat'] leading-relaxed mb-6">{teste.descricao}</p>

                {/* Preview de pergunta */}
                <div className={`${teste.corBg} border ${teste.corBorder} rounded-xl p-5 mb-6`}>
                  <p className="text-white/30 text-[10px] font-semibold tracking-widest uppercase font-['Montserrat'] mb-3">
                    Preview do teste
                  </p>
                  <p className={`${teste.cor} text-sm font-semibold font-['Montserrat'] mb-3 leading-relaxed`}>
                    {teste.preview.pergunta}
                  </p>
                  <div className="space-y-2">
                    {teste.preview.opcoes.map((op, i) => (
                      <div key={i} className="flex items-start gap-2.5 bg-white/5 rounded-lg px-3 py-2">
                        <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <div className={`w-3 h-3 rounded-full border ${teste.corBorder}`} />
                        </div>
                        <span className="text-white/50 text-xs font-['Montserrat']">{op}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Resultado esperado */}
                <div className="flex items-center gap-2.5 mb-7">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-award-line text-gold-400 text-sm" />
                  </div>
                  <p className="text-white/50 text-xs font-['Montserrat']">
                    Resultado: <span className="text-white/75 font-semibold">{teste.resultado}</span>
                  </p>
                </div>

                {/* CTA principal */}
                <Link
                  to={teste.link}
                  className={`flex items-center justify-center gap-2.5 w-full py-3.5 rounded-xl font-bold text-sm font-['Montserrat'] tracking-wide transition-all whitespace-nowrap bg-gradient-to-r from-gold-500 to-gold-700 text-[#0a0a0a] hover:from-gold-400 hover:to-gold-600`}
                >
                  <i className="ri-play-circle-line text-base" />
                  Fazer o teste gratuitamente
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>

            {/* Coluna direita — Instagram kit */}
            <div className="lg:col-span-2 flex flex-col gap-4">

              {/* Card Instagram */}
              <div className="bg-[#111111] border border-white/6 rounded-2xl p-6 flex-1">
                <div className="flex items-center gap-2 mb-5">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className="ri-instagram-line text-pink-400 text-lg" />
                  </div>
                  <span className="text-white/70 text-sm font-bold font-['Montserrat']">Kit para o Instagram</span>
                  <span className="ml-auto px-2 py-0.5 bg-green-500/10 border border-green-500/20 rounded-full text-green-400 text-[10px] font-bold font-['Montserrat']">
                    100% grátis
                  </span>
                </div>

                {/* Prévia do post */}
                <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-4 mb-4">
                  <div className="flex items-center gap-2.5 mb-3">
                    <div className="w-7 h-7 rounded-full bg-gradient-to-br from-gold-400 to-gold-700 flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-fill text-[#0a0a0a] text-xs" />
                    </div>
                    <div>
                      <p className="text-white/70 text-xs font-bold font-['Montserrat']">seu_perfil</p>
                      <p className="text-white/30 text-[10px] font-['Montserrat']">Agora</p>
                    </div>
                  </div>
                  <p className="text-white/55 text-xs font-['Montserrat'] leading-relaxed mb-3">
                    {teste.compartilhavel}
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {teste.hashtags.map((h, i) => (
                      <span key={i} className="text-[10px] text-gold-400/70 font-['Montserrat']">{h}</span>
                    ))}
                    <span className="text-[10px] text-gold-400/70 font-['Montserrat']">🔗 Link na bio</span>
                  </div>
                </div>

                {/* Botão copiar legenda */}
                <button
                  onClick={copiarLegenda}
                  className={`flex items-center justify-center gap-2 w-full py-3 rounded-xl font-semibold text-xs font-['Montserrat'] transition-all cursor-pointer whitespace-nowrap border ${
                    copiado
                      ? 'bg-green-500/15 border-green-500/30 text-green-400'
                      : 'bg-white/5 border-white/10 text-white/60 hover:bg-white/10 hover:text-white/90'
                  }`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${copiado ? 'ri-check-line' : 'ri-clipboard-line'} text-sm`} />
                  </div>
                  {copiado ? 'Legenda copiada!' : 'Copiar legenda pronta'}
                </button>

                <div className="mt-3 flex items-start gap-2 p-3 bg-gold-500/5 border border-gold-500/10 rounded-lg">
                  <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-lightbulb-line text-gold-400 text-xs" />
                  </div>
                  <p className="text-white/35 text-[11px] font-['Montserrat'] leading-relaxed">
                    <strong className="text-white/55">Como usar:</strong> Faça o teste, receba o resultado, copie a legenda, poste nos stories ou feed e coloque o link do teste na bio.
                  </p>
                </div>
              </div>

              {/* Mini cards dos outros testes */}
              <div className="bg-[#111111] border border-white/6 rounded-2xl p-5">
                <p className="text-white/25 text-[10px] font-semibold tracking-widest uppercase font-['Montserrat'] mb-3">
                  Outros testes
                </p>
                <div className="space-y-2">
                  {testes.filter((_, i) => i !== abaAtiva).map((t, i) => (
                    <button
                      key={t.id}
                      onClick={() => setAbaAtiva(testes.indexOf(t))}
                      className="w-full flex items-center gap-3 p-2.5 rounded-lg hover:bg-white/5 transition-colors cursor-pointer text-left group"
                    >
                      <div className={`w-7 h-7 flex items-center justify-center rounded-lg ${t.corBg} border ${t.corBorder} flex-shrink-0`}>
                        <i className={`${t.icon} ${t.cor} text-xs`} />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-white/60 group-hover:text-white/90 text-xs font-semibold font-['Montserrat'] transition-colors truncate">
                          {t.titulo}
                        </p>
                        <p className="text-white/25 text-[10px] font-['Montserrat']">{t.duracao} · {t.perguntas} perguntas</p>
                      </div>
                      <i className="ri-arrow-right-line text-white/20 group-hover:text-white/50 text-xs transition-colors flex-shrink-0" />
                    </button>
                  ))}
                </div>
              </div>

              {/* Stat de compartilhamento */}
              <div className="bg-gradient-to-br from-[#1a1400] to-[#0f0c00] border border-gold-500/15 rounded-2xl p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-share-circle-line text-gold-400" />
                  </div>
                  <span className="text-white/70 text-xs font-bold font-['Montserrat']">Por que compartilhar?</span>
                </div>
                <div className="space-y-2">
                  {[
                    { icon: 'ri-group-line', txt: 'Aumenta engajamento dos seguidores' },
                    { icon: 'ri-heart-line', txt: 'Gera curiosidade e interações' },
                    { icon: 'ri-link-m', txt: 'Direciona tráfego grátis pro site' },
                  ].map((item, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className={`${item.icon} text-gold-400/60 text-xs`} />
                      </div>
                      <span className="text-white/40 text-[11px] font-['Montserrat']">{item.txt}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </ScrollRevealWrapper>

        {/* Strip de stats */}
        <ScrollRevealWrapper animation="fade-up" delay={0.25}>
          <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-8 py-6 border-t border-gold-500/10">
            {[
              { n: '4 testes', l: 'disponíveis gratuitamente', i: 'ri-test-tube-line' },
              { n: '10k+', l: 'testes realizados', i: 'ri-group-line' },
              { n: '100%', l: 'gratuito e sem cadastro', i: 'ri-shield-check-line' },
              { n: '2 min', l: 'resultado imediato', i: 'ri-flashlight-line' },
            ].map((s, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${s.i} text-gold-400 text-base`} />
                </div>
                <div>
                  <span className="text-gold-400 font-bold text-sm font-['Montserrat']">{s.n}</span>
                  <span className="text-white/35 text-sm font-['Montserrat']"> {s.l}</span>
                </div>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}
